import React from 'react';
import gql from 'graphql-tag';
import { curry, get, set, omit } from 'lodash';
import { Mutation } from 'react-apollo';

import { updateItemById } from '../utils';
import { emptyRequestLine, RequestLineFieldsFragment } from '../constants';
import { query, NAME as REQUEST_LINES_QUERY } from '../withCaseRequestLines';
import { CASE_REQUEST_ASSETS_QUERY_NAME } from '../../RequestAssetsForm/withRequestAssets/caseRequestAssetsQuery';

const NAME = 'compositions_CaseRequestPanel_CaseUpdateRequestLine';

const mutation = gql`
  mutation ${NAME} (
    $assetId: String,
    $id: ID!,
    $loadRange: String,
    $manufacturerFullName: String,
    $productType: String,
    $requestedAction: RequestedAction,
    $rimType: RimType,
    $sculptureTreadName: String,
    $tireCondition: TireCondition,
    $tirePosition: TirePosition,
    $tireSize: String,
    $axleType: String,
  ) {
    updateCaseRequestLine(
      input: {
        id: $id,
        patch: {
          requestLine: {
            assetId: $assetId,
            loadRange: $loadRange,
            manufacturerFullName: $manufacturerFullName,
            productType: $productType,
            requestedAction: $requestedAction,
            rimType: $rimType,
            sculptureTreadName: $sculptureTreadName,
            tireCondition: $tireCondition,
            tirePosition: $tirePosition,
            tireSize: $tireSize,
            axleType: $axleType,
          }
        }
      },
    ) {
      requestLine { ...RequestLineFields }
    }
  }
  ${RequestLineFieldsFragment}
`;

const buildMutationChild = curry((WrappedComponent, componentProps, mutate) => {
  const updateRequestedLine = values =>
    mutate({
      variables: {
        ...omit(values, 'asset'),
        assetId: get(values, 'asset.id'),
      },
      optimisticResponse: {
        updateCaseRequestLine: {
          __typename: 'CaseRequestLinePayload',
          requestLine: {
            __typename: 'CaseRequestLine',
            asset: values.asset
              ? { ...values.asset, __typename: 'Asset' }
              : null,
            ...omit(values, 'asset'),
          },
        },
      },
      update: (store, { data }) => {
        const variables = { caseNumber: componentProps.caseNumber };
        const cache = store.readQuery({ query, variables });

        const lines = updateItemById(
          get(cache, 'case.requestLines', []),
          values.id,
          {
            ...emptyRequestLine,
            ...values,
            ...get(data, 'updateCaseRequestLine.requestLine'),
          },
        );

        store.writeQuery({
          query,
          data: set(cache, 'case.requestLines', lines),
          variables,
        });
      },
    });

  return (
    <WrappedComponent
      {...componentProps}
      updateRequestedLine={updateRequestedLine}
    />
  );
});

const withCaseUpdateRequestLines = WrappedComponent => componentProps => (
  <Mutation
    mutation={mutation}
    refetchQueries={[CASE_REQUEST_ASSETS_QUERY_NAME, REQUEST_LINES_QUERY]}
  >
    {buildMutationChild(WrappedComponent, componentProps)}
  </Mutation>
);

export default withCaseUpdateRequestLines;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestLinesActions/withCaseUpdateRequestLine.js